import styled from 'styled-components';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import MobileLearnMore from './MobileLearnMore';
import TooltipText from './TooltipText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Tooltip = styled.span.withConfig({
  displayName: "TitleTooltip__Tooltip",
  componentId: "sc-13leqhc-0"
})(["display:inline;font-size:1rem;"]);
export const TitleTooltip = ({
  stepKey,
  tooltipLink
}) => {
  const {
    isMobile: isMobileTooltip
  } = useResponsiveness();
  const getTooltipText = (isMobile = false) => {
    return /*#__PURE__*/_jsx(TooltipText, {
      isMobile: isMobile,
      stepKey: stepKey,
      tooltipLink: tooltipLink
    });
  };
  return /*#__PURE__*/_jsxs("span", {
    children: [!isMobileTooltip && /*#__PURE__*/_jsx(Tooltip, {
      children: /*#__PURE__*/_jsx(UIHelpIcon, {
        title: getTooltipText(),
        tooltipPlacement: "right",
        tooltipProps: {
          use: 'longform'
        }
      })
    }), /*#__PURE__*/_jsx(MobileLearnMore, {
      stepKey: stepKey,
      tooltipText: getTooltipText()
    })]
  });
};